import { removeAsterisk } from '@app/finxone-web-frontend/app/lib/utils/validators/validators.utils';

/**
 * Validation message formatting rules:
 * - Capitalized first letter
 * - No full stop at the end
 * - Names are capitalized where applicable e.g. Month names
 */
export const defaultValidationMessages = {
  required: (fieldName: string) => `${fieldName ? removeAsterisk(fieldName) : 'This'} is a required field`,
  requiredTrue: 'This field must be checked',
  email: 'Please enter valid email address',
  minlength: (min: number) => `Minimum allowed characters is ${min}`,
  maxlength: (max: number) => `Maximum allowed characters is ${max}`,
  phoneValidation: 'Please enter valid phone number',
  noNumbers: (fieldName?: string) =>
    `${fieldName ? removeAsterisk(fieldName) : 'Field'} cannot include numbers`,
  noSpecialChars: (fieldName?: string) =>
    `${fieldName ? removeAsterisk(fieldName) + ' ' : 'Field '}cannot include special characters`,
  range: (fieldName: string, min: number, max: number) =>
    `${fieldName ? removeAsterisk(fieldName) : 'Field'} must be between ${min} and ${max}`,
  invalidDayOfMonthYear: (day: number, monthName: string | undefined, year: number) =>
    `There are not ${day} days in ${monthName ? monthName : 'Unknown Month'} ${year}`,
  invalidDate: 'Invalid date provided',
  minAge: (minage: number) => `You must be ${minage} years old or above to apply`,
  invalidInput: (fieldName?: string) =>
    `${fieldName ? removeAsterisk(fieldName) + ' ' : 'Field '}does not meet the required criteria.`,
};
